import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import { api } from '../utils/api';

export const getUsers = async (accountId) => {
    try {
        const usersRef = collection(db, `accounts/${accountId}/users`);
        const snapshot = await getDocs(usersRef);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error getting users:', error);
        throw error;
    }
};

export const createUser = async (accountId, userData) => {
    try {
        // Call the backend API endpoint
        const response = await api.post('/api/users/signup', {  
            ...userData,
            accountID: accountId
        });

        if (!response.success) {
            throw new Error(response.message || 'Failed to create user');
        }

        return response.userId;
    } catch (error) {
        console.error('Error creating/updating user:', error);
        throw error;
    }
};

export const getBarBySlug = async (slug) => {
    try {
        const accountsRef = collection(db, 'accounts');
        const q = query(accountsRef, where("slug", "==", slug));
        const snapshot = await getDocs(q);
        
        if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            return { id: doc.id, ...doc.data() };
        }
        return null;
    } catch (error) {
        console.error('Error getting bar by slug:', error);
        throw error;
    }
};
